import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // While auth resolves, the HTML boot-splash (index.html #boot-splash) is
  // still mounted above us; rendering anything here just adds a SECOND
  // loader that flashes through. Return null — the splash IS the loader.
  if (isLoading) return null;

  // Куда человек шёл — запоминаем. По кнопке из уведомления приходят сразу на
  // /tasks/open/<id>; если сессии не оказалось, без этого он после входа
  // попадал бы в чат, а задача, ради которой он нажал кнопку, терялась.
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
}
